var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:['is-' + _vm.kind, { 'is-block': _vm.block, 'is-loading': _vm.loading }],attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }